const initialState = {
  images: [],
  isOpen: false,
  currentImage: 0
};

export const lightboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_LIGHTBOX": {
      return initialState;
    }
    case "SET_LIGHTBOX": {
      return { ...state, ...action.lightbox };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/lightbox.js